module.exports = __webpack_public_path__ + "static/media/icn-medal-updated.68f9d84e.png";